/** True when the page is opened for Figma html-to-design capture (#figmacapture=…): paint every reveal, skip motion. */
export const isFigmaCapture =
  typeof window !== 'undefined' && /figmacapture=/.test(window.location.hash || '');
